import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  DataTable,
  DateTimeField,
  Field,
} from '../../../commons/DataTable';
import SupplierAgreementField from '../../../commons/DataTable/SupplierAgreementField';
import ActionsFieldExternal from './ActionsFieldExternal';

function ExternalAdminAgreementsTable({
  data,
  total,
  offset,
  limit,
  onFilter,
  handleFileListViewExternal,
}) {
  const [t] = useTranslation();

  return (
    <DataTable
      data={data}
      total={total}
      offset={offset}
      limit={limit}
      onFilter={onFilter}
      emptyText={t('COMMON:NO_DATA')}
    >
      <Field title="Nome contratto" source="name" className="text-center" />
      <SupplierAgreementField
        title="Tipo fornitore"
        source="isExternalSupplier"
        className="text-center"
      />
      <Field
        title="Fornitore"
        source="supplier.businessName"
        className="text-center"
      />
      <Field
        title="Codice Fiscale Fornitore"
        source="supplier.fiscalCode"
        className="text-center"
      />
      <DateTimeField
        title="Data creazione"
        source="createdAt"
        format="DD/MM/YYYY"
      />
      <ActionsFieldExternal
        title="Azioni"
        handleFileListView={handleFileListViewExternal}
      />
    </DataTable>
  );
}

export default ExternalAdminAgreementsTable;
